import React from 'react'
import FormItem from '../FormItem';

const Forms = () => {

    return (
        <FormItem />
    )
}

export default Forms